'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axiosInterceptorsLoader = require('./axios-interceptors-loader');

var _axiosInterceptorsLoader2 = _interopRequireDefault(_axiosInterceptorsLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (axios, _ref) {
  var req = _ref.req,
      _ref$loadInterceptors = _ref.loadInterceptors,
      loadInterceptors = _ref$loadInterceptors === undefined ? true : _ref$loadInterceptors;

  var instance = axios.create({
    baseURL: axios.defaults.baseURL,
    headers: req.headers
  });

  instance.unregisterWixInterceptors = _axiosInterceptorsLoader2.default.loadIfNeeded(instance, loadInterceptors);
  return instance;
};
//# sourceMappingURL=wix-axios-instance-config.js.map



//////////////////
// WEBPACK FOOTER
// ../~/wix-axios-config/dist/src/wix-axios-instance-config.js
// module id = 867
// module chunks = 0